export default {
  namespaced: true,
  state: {
    show: false,
    src: null
  },
  mutations: {
    toggleModal (state, value) {
      state.show = value
    },
    setSrc (state, src) {
      state.src = src
    },
    unSetSrc (state) {
      state.src = null
    }
  },
  actions: {
    toggleShow (context, payload) {
      context.commit('toggleModal', payload.value)
      if (payload.src) {
        context.commit('setSrc', payload.src)
      } else {
        context.commit('unSetSrc')
      }
    }

  }
}



// WEBPACK FOOTER //
// ./src/store/modules/video.js